var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"side_ads",staticClass:"side-ads ad-slot"},[_c('div',{staticClass:"ad_container"},[_c('div',{staticClass:"ad_wrapper"},[(_vm.screen.isDesktop)?_c('div',{attrs:{"id":"div-gpt-ad-1556609030596-0"}}):_c('div',{attrs:{"id":"div-gpt-ad-1556161782064-0"}})])])])
}
var staticRenderFns = []

export { render, staticRenderFns }